import React from 'react';
import classNames from 'classnames';
import EllipseIcon from 'components/atoms/icons/ellipse';
import HospitalIcon from 'components/atoms/icons/hospital';
import BaseCheckbox from 'components/atoms/base-checkbox';
import BaseTag from 'components/atoms/base-tag';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

interface IProps {
  name: string;
  isParent: boolean;
  isLast: boolean;
  checked: boolean;
  withoutParent?: boolean;
  showIcon?: boolean;
  allChildrenChecked?: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  onChildrenChange?: (checked: boolean) => void;
}

const ClinicFilterFormListItem: React.FC<IProps> = ({
  name,
  isParent,
  isLast,
  checked,
  showIcon = true,
  withoutParent = false,
  allChildrenChecked = false,
  disabled = false,
  onChange,
  onChildrenChange,
}) => {
  const { t } = useTranslation();

  const icon = isParent ? <HospitalIcon size="small" /> : <EllipseIcon />;

  const isParentClinicWithChildren = isParent && !isLast;

  const itemClassNames = classNames(s.item, {
    [s.child]: !isParent && !withoutParent,
    [s.parent]: isParentClinicWithChildren,
    [s.disabled]: disabled,
  });

  return (
    <li
      className={itemClassNames}
      onClick={() => !disabled && onChange(!checked)}
      data-cy="clinicList-item"
    >
      <div className={s.title} data-cy="clinicList-title">
        {showIcon && <i>{icon}</i>}
        {name}
        {isParentClinicWithChildren && <BaseTag label={t('labels.parent')} />}
      </div>

      <div className={s['right-side']} data-cy="clinicList-checkbox">
        {isParentClinicWithChildren && onChildrenChange && (
          <div
            className={s['children-toggle']}
            onClick={(e) => {
              e.stopPropagation();
              onChildrenChange(!allChildrenChecked);
            }}
          >
            <span className={s['children-label']}>
              {t('labels.allChildren')}
            </span>
            <BaseCheckbox value={allChildrenChecked} />
          </div>
        )}
        <div className={s.checkbox}>
          <BaseCheckbox value={checked} disabled={disabled} />
        </div>
      </div>
    </li>
  );
};

export default ClinicFilterFormListItem;
